module.exports = __webpack_public_path__ + "static/media/doclad13.9e2bf706.pdf";